import moment from 'moment';

// OrderPackage#appointment_time stores an appointment's wall-clock time with
// Pacific digits labeled UTC — e.g. a 9:00 AM appointment is stored as 09:00
// UTC. We always read it back in UTC so those digits display unchanged.
//
// The API serializes it as ISO 8601 ("2026-09-01T09:00:00Z"). Older or cached
// payloads may still carry Rails' legacy `Time#to_s` form
// ("2026-09-01 09:00:00 UTC"). We parse against an explicit format list so
// Moment never falls back to the JS engine's native `Date` parser — that
// fallback returns "Invalid Date" on iOS/Safari for the non-ISO form, which is
// the bug this utility exists to prevent. Every appointment display in the
// customer app must go through here rather than calling `moment()` / `new Date`
// directly.
const APPOINTMENT_FORMATS = [
  moment.ISO_8601,
  'YYYY-MM-DD HH:mm:ss [UTC]',
  'YYYY-MM-DD HH:mm:ss',
];

export const parseAppointment = (value) => moment.utc(value, APPOINTMENT_FORMATS, true);

export const formatAppointmentDate = (value, format = 'dddd, MMMM D, YYYY') => (
  parseAppointment(value).format(format)
);

export const formatAppointmentTime = (value, format = 'h:mm A') => (
  parseAppointment(value).format(format)
);
